import React, { useState, useEffect, useMemo, useContext } from "react";

import { BrowserRouter, Switch, Route } from "react-router-dom";

import Login from "../Login";
import Dashboard from "../../components/Dashboard";
import NotFound from "../NotFound";
import ForgetPassword from "../ForgetPassword";
import ResetPassword from "../ResetPassword";
import FirstLogin from "../FirstLogin";

import Loading from "../Loading";

import { GuardProvider, GuardedRoute } from "react-router-guards";

import { AuthProvider, AuthContext } from "../../utils/userProvider";

import ProtectedRoute from "./ProtectedRoute";

function App() {
  const { authState } = useContext(AuthContext);
  const requireLogin = (to, from, next) => {
    if (to.match.path === "/") {
      if (authState.jwt ? authState.jwt : "" != null) {
        if (authState.jwt ? authState.jwt : "".length !== 0) {
          if (localStorage.getItem("firstLogin") == true) {
            next.redirect("/firstLogin");
          } else {
            next.redirect("/dashboard");
          }
        }
      }
    }

    if (to.meta.requireAuth) {
      if (authState.jwt ? authState.jwt : "" != null) {
        if (authState.jwt ? authState.jwt : "".length !== 0) next();
        else {
          next.redirect("/");
        }
      } else {
        next.redirect("/");
      }
    } else next();
  };

  /* const [authState, setAuthState] = useState(null); */
  /* const [isAuth, setIsAuth] = useState(false); */

  /* useEffect(() => {
    if (authState != null) {
      if (authState.jwt != null) {
        setIsAuth(true);
      } else {
        setIsAuth(false);
      }
    } else {
      setIsAuth(false);
    }
  }, authState); */

  /* const providerValue = useMemo(
    () => ({ authState, setAuthState }),
    [authState, setAuthState]
  );
    */

  return (
    <BrowserRouter>
      {/* <GuardProvider guards={[requireLogin]} loading={Loading} error={NotFound}>
        <Switch>
          <GuardedRoute path="/" exact component={Login} />
          <GuardedRoute
            path="/forgetpassword"
            exact
            component={ForgetPassword}
          />
          <GuardedRoute path="/resetPassword" exact component={ResetPassword} />
          <GuardedRoute
            meta={{ requireAuth: true }}
            path="/dashboard"
            component={Dashboard}
          />
          <GuardedRoute
            meta={{ requireAuth: true }}
            path="/firstLogin"
            component={FirstLogin}
          />
          <GuardedRoute path="*" component={NotFound} />
        </Switch>
      </GuardProvider> */}
      <Switch>
        <Route path="/" exact render component={Login} />
        <Route path="/forgetpassword" exact component={ForgetPassword} />
        <Route path="/resetPassword" exact component={ResetPassword} />
        <ProtectedRoute path="/dashboard" component={Dashboard} />
        <ProtectedRoute path="/firstLogin" component={FirstLogin} />
        <Route path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
